import { Navigate, Outlet } from "react-router-dom";
import Header from "../_components/common/Header";
import Footer from "../_components/common/Footer";

const ProtectedRoutesOutlet = () => {
  const auth = { token: sessionStorage.getItem("sal_token") };
  // const auth = { token: "Authenticated" };
  // const auth = { token: null };
  return auth.token ? (
    <>
      {/* Header | Footer | Drawer for Protected Routes add here */}
      <header className="App-header">
        <Header />
      </header>
      <Outlet />
      <footer className="app-footer">
        <Footer />
      </footer>
    </>
  ) : (
    <Navigate to="/unauthorized" />
  );
};

export default ProtectedRoutesOutlet;
